export const countryList = [
  {
    countryCode: 'AFG',
    en: 'Afghanistan',
    tc: '阿富汗',
    sc: '阿富汗',
  },
  {
    countryCode: 'ALB',
    en: 'Albania',
    tc: '亞爾巴尼亞',
    sc: '亚尔巴尼亚',
  },
  {
    countryCode: 'DZA',
    en: 'Algeria',
    tc: '阿爾及利亞',
    sc: '阿尔及利亚',
  },
  {
    countryCode: 'ASM',
    en: 'American Samoa',
    tc: '美屬薩摩亞',
    sc: '美属萨摩亚',
  },
  {
    countryCode: 'AND',
    en: 'Andorra',
    tc: '安道爾',
    sc: '安道尔',
  },
  {
    countryCode: 'AGO',
    en: 'Angola',
    tc: '安哥拉',
    sc: '安哥拉',
  },
  {
    countryCode: 'AIA',
    en: 'Anguilla',
    tc: '安圭拉島',
    sc: '安圭拉岛',
  },
  {
    countryCode: 'ATG',
    en: 'Antigua and Barbuda',
    tc: '安提瓜',
    sc: '安提瓜',
  },
  {
    countryCode: 'ARG',
    en: 'Argentina',
    tc: '阿根廷',
    sc: '阿根廷',
  },
  {
    countryCode: 'ARM',
    en: 'Armenia',
    tc: '亞美尼亞',
    sc: '亚美尼亚',
  },
  {
    countryCode: 'ABW',
    en: 'Aruba',
    tc: '阿魯巴島',
    sc: '阿鲁巴岛',
  },
  {
    countryCode: 'AUS',
    en: 'Australia',
    tc: '澳洲',
    sc: '澳洲',
  },
  {
    countryCode: 'AUT',
    en: 'Austria',
    tc: '奧地利',
    sc: '奥地利',
  },
  {
    countryCode: 'AZE',
    en: 'Azerbaijan',
    tc: '亞塞拜疆',
    sc: '亚塞拜疆',
  },
  {
    countryCode: 'BHS',
    en: 'Bahamas',
    tc: '巴哈馬',
    sc: '巴哈马',
  },
  {
    countryCode: 'BHR',
    en: 'Bahrain',
    tc: '巴林',
    sc: '巴林',
  },
  {
    countryCode: 'BGD',
    en: 'Bangladesh',
    tc: '孟加拉國',
    sc: '孟加拉国',
  },
  {
    countryCode: 'BRB',
    en: 'Barbados',
    tc: '巴巴多斯',
    sc: '巴巴多斯',
  },
  {
    countryCode: 'BLR',
    en: 'Belarus',
    tc: '白俄羅斯',
    sc: '白俄罗斯',
  },
  {
    countryCode: 'BEL',
    en: 'Belgium',
    tc: '比利時',
    sc: '比利时',
  },
  {
    countryCode: 'BLZ',
    en: 'Belize',
    tc: '伯利茲',
    sc: '伯利兹',
  },
  {
    countryCode: 'BEN',
    en: 'Benin',
    tc: '貝寧',
    sc: '贝宁',
  },
  {
    countryCode: 'BMU',
    en: 'Bermuda',
    tc: '百慕達',
    sc: '百慕达',
  },
  {
    countryCode: 'BTN',
    en: 'Bhutan',
    tc: '不丹',
    sc: '不丹',
  },
  {
    countryCode: 'BOL',
    en: 'Bolivia',
    tc: '玻利維亞',
    sc: '玻利维亚',
  },
  {
    countryCode: 'BIH',
    en: 'Bosnia and Herzegovina',
    tc: '波斯尼亞和黑塞哥維那',
    sc: '波斯尼亚和黑塞哥维那',
  },
  {
    countryCode: 'BWA',
    en: 'Botswana',
    tc: '博茨瓦納',
    sc: '博茨瓦纳',
  },
  {
    countryCode: 'BRA',
    en: 'Brazil',
    tc: '巴西',
    sc: '巴西',
  },
  {
    countryCode: 'IOT',
    en: 'British Indian Ocean Territory',
    tc: '英屬印度洋屬土',
    sc: '英属印度洋属土',
  },
  {
    countryCode: 'VGB',
    en: 'British Virgin Islands',
    tc: '維京群島',
    sc: '维京群岛',
  },
  {
    countryCode: 'BRN',
    en: 'Brunei Darussalam',
    tc: '文萊達魯薩蘭國',
    sc: '文莱达鲁萨兰国',
  },
  {
    countryCode: 'BGR',
    en: 'Bulgaria',
    tc: '保加利亞',
    sc: '保加利亚',
  },
  {
    countryCode: 'BFA',
    en: 'Burkina Faso',
    tc: '布基納法索',
    sc: '布基纳法索',
  },
  {
    countryCode: 'BDI',
    en: 'Burundi',
    tc: '布隆迪',
    sc: '布隆迪',
  },
  {
    countryCode: 'CPV',
    en: 'Cabo Verde',
    tc: '佛得角',
    sc: '佛得角',
  },
  {
    countryCode: 'KHM',
    en: 'Cambodia',
    tc: '柬埔寨',
    sc: '柬埔寨',
  },
  {
    countryCode: 'CMR',
    en: 'Cameroon',
    tc: '喀麥隆',
    sc: '喀麦隆',
  },
  {
    countryCode: 'CAN',
    en: 'Canada',
    tc: '加拿大',
    sc: '加拿大',
  },
  {
    countryCode: 'BES',
    en: 'Caribbean Netherlands',
    tc: '荷屬加勒比地區',
    sc: '荷属加勒比地区',
  },
  {
    countryCode: 'CYM',
    en: 'Cayman Islands',
    tc: '開曼群島',
    sc: '开曼群岛',
  },
  {
    countryCode: 'CAF',
    en: 'Central African Republic',
    tc: '中非共和國',
    sc: '中非共和国',
  },
  {
    countryCode: 'TCD',
    en: 'Chad',
    tc: '乍得',
    sc: '乍得',
  },
  {
    countryCode: 'CHL',
    en: 'Chile',
    tc: '智利',
    sc: '智利',
  },
  {
    countryCode: 'COL',
    en: 'Colombia',
    tc: '哥倫比亞',
    sc: '哥伦比亚',
  },
  {
    countryCode: 'COM',
    en: 'Comoros',
    tc: '科摩羅群島',
    sc: '科摩罗群岛',
  },
  {
    countryCode: 'COG',
    en: 'Congo',
    tc: '剛果',
    sc: '刚果',
  },
  {
    countryCode: 'COK',
    en: 'Cook Islands',
    tc: '庫克群島',
    sc: '库克群岛',
  },
  {
    countryCode: 'CRI',
    en: 'Costa Rica',
    tc: '哥斯達黎加',
    sc: '哥斯达黎加',
  },
  {
    countryCode: 'CIV',
    en: "Cote d'Ivoire",
    tc: '象牙海岸',
    sc: '科特迪瓦',
  },
  {
    countryCode: 'HRV',
    en: 'Croatia',
    tc: '克羅地亞',
    sc: '克罗地亚',
  },
  {
    countryCode: 'CUB',
    en: 'Cuba',
    tc: '古巴',
    sc: '古巴',
  },
  {
    countryCode: 'CUW',
    en: 'Curacao',
    tc: '庫拉索',
    sc: '库拉索',
  },
  {
    countryCode: 'CYP',
    en: 'Cyprus',
    tc: '塞浦路斯',
    sc: '塞浦路斯',
  },
  {
    countryCode: 'CZE',
    en: 'Czech Republic',
    tc: '捷克共和國',
    sc: '捷克共和国',
  },
  {
    countryCode: 'COD',
    en: 'Democratic Republic of the Congo',
    tc: '剛果民主共和國',
    sc: '刚果民主共和国',
  },
  {
    countryCode: 'DNK',
    en: 'Denmark',
    tc: '丹麥',
    sc: '丹麦',
  },
  {
    countryCode: 'DJI',
    en: 'Djibouti',
    tc: '吉布提',
    sc: '吉布提',
  },
  {
    countryCode: 'DMA',
    en: 'Dominica',
    tc: '多明尼加',
    sc: '多米尼加',
  },
  {
    countryCode: 'DOM',
    en: 'Dominican Republic',
    tc: '多米尼加共和國',
    sc: '多米尼加共和国',
  },
  {
    countryCode: 'ECU',
    en: 'Ecuador',
    tc: '厄瓜多爾',
    sc: '厄瓜多尔',
  },
  {
    countryCode: 'EGY',
    en: 'Egypt',
    tc: '埃及',
    sc: '埃及',
  },
  {
    countryCode: 'SLV',
    en: 'El Salvador',
    tc: '薩爾瓦多',
    sc: '萨尔瓦多',
  },
  {
    countryCode: 'GNQ',
    en: 'Equatorial Guinea',
    tc: '赤道畿內亞',
    sc: '赤道几内亚',
  },
  {
    countryCode: 'ERI',
    en: 'Eritrea',
    tc: '厄立特里亞',
    sc: '厄立特里亚',
  },
  {
    countryCode: 'EST',
    en: 'Estonia',
    tc: '愛沙尼亞',
    sc: '爱沙尼亚',
  },
  {
    countryCode: 'ETH',
    en: 'Ethiopia',
    tc: '埃塞俄比亞',
    sc: '埃塞俄比亚',
  },
  {
    countryCode: 'FLK',
    en: 'Falkland Islands',
    tc: '福克蘭群島',
    sc: '福克兰群岛',
  },
  {
    countryCode: 'FRO',
    en: 'Faroe Islands',
    tc: '法羅群島',
    sc: '法罗群岛',
  },
  {
    countryCode: 'FJI',
    en: 'Fiji',
    tc: '斐濟',
    sc: '斐济',
  },
  {
    countryCode: 'FIN',
    en: 'Finland',
    tc: '芬蘭',
    sc: '芬兰',
  },
  {
    countryCode: 'FRA',
    en: 'France',
    tc: '法國',
    sc: '法国',
  },
  {
    countryCode: 'GUF',
    en: 'French Guiana',
    tc: '法屬圭亞那',
    sc: '法属圭亚那',
  },
  {
    countryCode: 'PYF',
    en: 'French Polynesia',
    tc: '法屬波利尼西亞',
    sc: '法属波利尼西亚',
  },
  {
    countryCode: 'GAB',
    en: 'Gabon',
    tc: '加篷',
    sc: '加篷',
  },
  {
    countryCode: 'GMB',
    en: 'Gambia',
    tc: '岡比亞',
    sc: '冈比亚',
  },
  {
    countryCode: 'GEO',
    en: 'Georgia',
    tc: '格魯吉亞',
    sc: '格鲁吉亚',
  },
  {
    countryCode: 'DEU',
    en: 'Germany',
    tc: '德國',
    sc: '德国',
  },
  {
    countryCode: 'GHA',
    en: 'Ghana',
    tc: '加納',
    sc: '加纳',
  },
  {
    countryCode: 'GIB',
    en: 'Gibraltar',
    tc: '直布羅陀',
    sc: '直布罗陀',
  },
  {
    countryCode: 'GRC',
    en: 'Greece',
    tc: '希臘',
    sc: '希腊',
  },
  {
    countryCode: 'GRL',
    en: 'Greenland',
    tc: '格陵蘭',
    sc: '格陵兰',
  },
  {
    countryCode: 'GRD',
    en: 'Grenada',
    tc: '格林納達',
    sc: '格林纳达',
  },
  {
    countryCode: 'GLP',
    en: 'Guadeloupe',
    tc: '瓜得羅普島',
    sc: '瓜得罗普岛',
  },
  {
    countryCode: 'GUM',
    en: 'Guam',
    tc: '關島',
    sc: '关岛',
  },
  {
    countryCode: 'GTM',
    en: 'Guatemala',
    tc: '危地馬拉',
    sc: '危地马拉',
  },
  {
    countryCode: 'GIN',
    en: 'Guinea',
    tc: '畿內亞',
    sc: '几内亚',
  },
  {
    countryCode: 'GNB',
    en: 'Guinea Bissau',
    tc: '畿內亞比紹',
    sc: '几内亚比绍',
  },
  {
    countryCode: 'GUY',
    en: 'Guyana',
    tc: '圭亞那',
    sc: '圭亚那',
  },
  {
    countryCode: 'HTI',
    en: 'Haiti',
    tc: '海地',
    sc: '海地',
  },
  {
    countryCode: 'HND',
    en: 'Honduras',
    tc: '洪都拉斯',
    sc: '洪都拉斯',
  },
  {
    countryCode: 'HKG',
    en: 'Hong Kong',
    tc: '香港',
    sc: '香港',
  },
  {
    countryCode: 'HUN',
    en: 'Hungary',
    tc: '匈牙利',
    sc: '匈牙利',
  },
  {
    countryCode: 'ISL',
    en: 'Iceland',
    tc: '冰島',
    sc: '冰岛',
  },
  {
    countryCode: 'IND',
    en: 'India',
    tc: '印度',
    sc: '印度',
  },
  {
    countryCode: 'IDN',
    en: 'Indonesia',
    tc: '印尼',
    sc: '印尼',
  },
  {
    countryCode: 'IRN',
    en: 'Iran',
    tc: '伊朗',
    sc: '伊朗',
  },
  {
    countryCode: 'IRQ',
    en: 'Iraq',
    tc: '伊拉克',
    sc: '伊拉克',
  },
  {
    countryCode: 'IRL',
    en: 'Ireland',
    tc: '愛爾蘭',
    sc: '爱尔兰',
  },
  {
    countryCode: 'ISR',
    en: 'Israel',
    tc: '以色列',
    sc: '以色列',
  },
  {
    countryCode: 'ITA',
    en: 'Italy',
    tc: '意大利',
    sc: '意大利',
  },
  {
    countryCode: 'JAM',
    en: 'Jamaica',
    tc: '牙買加',
    sc: '牙买加',
  },
  {
    countryCode: 'JPN',
    en: 'Japan',
    tc: '日本',
    sc: '日本',
  },
  {
    countryCode: 'JOR',
    en: 'Jordan',
    tc: '約旦',
    sc: '约旦',
  },
  {
    countryCode: 'KAZ',
    en: 'Kazakhstan',
    tc: '哈薩克',
    sc: '哈萨克',
  },
  {
    countryCode: 'KEN',
    en: 'Kenya',
    tc: '肯雅',
    sc: '肯尼亚',
  },
  {
    countryCode: 'KIR',
    en: 'Kiribati',
    tc: '基里巴斯',
    sc: '基里巴斯',
  },
  {
    countryCode: 'PRK',
    en: "Korea, Democratic People's Republic of",
    tc: '北韓',
    sc: '北韩',
  },
  {
    countryCode: 'KOR',
    en: 'Korea, Republic Of',
    tc: '南韓',
    sc: '南韩',
  },
  {
    countryCode: 'KWT',
    en: 'Kuwait',
    tc: '科威特',
    sc: '科威特',
  },
  {
    countryCode: 'KGZ',
    en: 'Kyrgyzstan',
    tc: '吉爾吉斯',
    sc: '吉尔吉斯',
  },
  {
    countryCode: 'LAO',
    en: 'Laos',
    tc: '寮國',
    sc: '寮国',
  },
  {
    countryCode: 'LVA',
    en: 'Latvia',
    tc: '拉脫維亞',
    sc: '拉脱维亚',
  },
  {
    countryCode: 'LBN',
    en: 'Lebanon',
    tc: '黎巴嫩',
    sc: '黎巴嫩',
  },
  {
    countryCode: 'LSO',
    en: 'Lesotho',
    tc: '萊索托',
    sc: '莱索托',
  },
  {
    countryCode: 'LBR',
    en: 'Liberia',
    tc: '利比里亞',
    sc: '利比里亚',
  },
  {
    countryCode: 'LBY',
    en: 'Libya',
    tc: '利比亞',
    sc: '利比亚',
  },
  {
    countryCode: 'LIE',
    en: 'Liechtenstein',
    tc: '列支敦士登',
    sc: '列支敦士登',
  },
  {
    countryCode: 'LTU',
    en: 'Lithuania',
    tc: '立陶宛',
    sc: '立陶宛',
  },
  {
    countryCode: 'LUX',
    en: 'Luxembourg',
    tc: '盧森堡',
    sc: '卢森堡',
  },
  {
    countryCode: 'MAC',
    en: 'Macao',
    tc: '澳門',
    sc: '澳门',
  },
  {
    countryCode: 'MDG',
    en: 'Madagascar',
    tc: '馬達加斯加',
    sc: '马达加斯加',
  },
  {
    countryCode: 'CHN',
    en: 'Mainland China',
    tc: '中國內地',
    sc: '中国内地',
  },
  {
    countryCode: 'MWI',
    en: 'Malawi',
    tc: '馬拉維',
    sc: '马拉维',
  },
  {
    countryCode: 'MYS',
    en: 'Malaysia',
    tc: '馬來西亞',
    sc: '马来西亚',
  },
  {
    countryCode: 'MDV',
    en: 'Maldives',
    tc: '馬爾代夫',
    sc: '马尔代夫',
  },
  {
    countryCode: 'MLI',
    en: 'Mali',
    tc: '馬里',
    sc: '马里',
  },
  {
    countryCode: 'MLT',
    en: 'Malta',
    tc: '馬耳他',
    sc: '马耳他',
  },
  {
    countryCode: 'MHL',
    en: 'Marshall Islands',
    tc: '馬紹爾群島',
    sc: '马绍尔群岛',
  },
  {
    countryCode: 'MTQ',
    en: 'Martinique',
    tc: '馬丁尼克',
    sc: '马丁尼克',
  },
  {
    countryCode: 'MRT',
    en: 'Mauritania',
    tc: '毛里塔尼亞',
    sc: '毛里塔尼亚',
  },
  {
    countryCode: 'MUS',
    en: 'Mauritius',
    tc: '毛里求斯',
    sc: '毛里求斯',
  },
  {
    countryCode: 'MYT',
    en: 'Mayotte',
    tc: '馬約特',
    sc: '马约特岛',
  },
  {
    countryCode: 'MEX',
    en: 'Mexico',
    tc: '墨西哥',
    sc: '墨西哥',
  },
  {
    countryCode: 'FSM',
    en: 'Micronesia, Federated States Of',
    tc: '密克羅尼西亞聯邦',
    sc: '密克罗尼西亚联邦',
  },
  {
    countryCode: 'MCO',
    en: 'Monaco',
    tc: '摩納哥',
    sc: '摩纳哥',
  },
  {
    countryCode: 'MNG',
    en: 'Mongolia',
    tc: '蒙古',
    sc: '蒙古',
  },
  {
    countryCode: 'MNE',
    en: 'Montenegro',
    tc: '黑山',
    sc: '黑山',
  },
  {
    countryCode: 'MSR',
    en: 'Montserrat',
    tc: '蒙特塞拉特島',
    sc: '蒙特塞拉特岛',
  },
  {
    countryCode: 'MAR',
    en: 'Morocco',
    tc: '摩洛哥',
    sc: '摩洛哥',
  },
  {
    countryCode: 'MOZ',
    en: 'Mozambique',
    tc: '莫桑比克',
    sc: '莫桑比克',
  },
  {
    countryCode: 'MMR',
    en: 'Myanmar',
    tc: '緬甸',
    sc: '缅甸',
  },
  {
    countryCode: 'NAM',
    en: 'Namibia',
    tc: '納米比亞',
    sc: '纳米比亚',
  },
  {
    countryCode: 'NRU',
    en: 'Nauru',
    tc: '那魯',
    sc: '那鲁',
  },
  {
    countryCode: 'NPL',
    en: 'Nepal',
    tc: '尼泊爾',
    sc: '尼泊尔',
  },
  {
    countryCode: 'NLD',
    en: 'Netherlands',
    tc: '荷蘭',
    sc: '荷兰',
  },
  {
    countryCode: 'NCL',
    en: 'New Caledonia',
    tc: '新喀里多尼亞',
    sc: '新喀里多尼亚',
  },
  {
    countryCode: 'NZL',
    en: 'New Zealand',
    tc: '新西蘭',
    sc: '新西兰',
  },
  {
    countryCode: 'NIC',
    en: 'Nicaragua',
    tc: '尼加拉瓜',
    sc: '尼加拉瓜',
  },
  {
    countryCode: 'NER',
    en: 'Niger',
    tc: '尼日爾',
    sc: '尼日尔',
  },
  {
    countryCode: 'NGA',
    en: 'Nigeria',
    tc: '尼日利亞',
    sc: '尼日利亚',
  },
  {
    countryCode: 'NIU',
    en: 'Niue Island',
    tc: '紐埃島',
    sc: '纽埃岛',
  },
  {
    countryCode: 'NFK',
    en: 'Norfolk Island',
    tc: '諾福克島',
    sc: '诺福克岛',
  },
  {
    countryCode: 'MKD',
    en: 'North Macedonia',
    tc: '北馬其頓',
    sc: '北马其顿',
  },
  {
    countryCode: 'MNP',
    en: 'Northern Mariana Islands',
    tc: '馬里亞納',
    sc: '马里亚纳',
  },
  {
    countryCode: 'NOR',
    en: 'Norway',
    tc: '挪威',
    sc: '挪威',
  },
  {
    countryCode: 'OMN',
    en: 'Oman',
    tc: '阿曼',
    sc: '阿曼',
  },
  {
    countryCode: 'PAK',
    en: 'Pakistan',
    tc: '巴基斯坦',
    sc: '巴基斯坦',
  },
  {
    countryCode: 'PLW',
    en: 'Palau',
    tc: '帕勞',
    sc: '帕劳',
  },
  {
    countryCode: 'PAN',
    en: 'Panama',
    tc: '巴拿馬',
    sc: '巴拿马',
  },
  {
    countryCode: 'PNG',
    en: 'Papua New Guinea',
    tc: '巴布亞新畿內亞',
    sc: '巴布亚新几内亚',
  },
  {
    countryCode: 'PRY',
    en: 'Paraguay',
    tc: '巴拉圭',
    sc: '巴拉圭',
  },
  {
    countryCode: 'PER',
    en: 'Peru',
    tc: '秘魯',
    sc: '秘鲁',
  },
  {
    countryCode: 'PHL',
    en: 'Philippines',
    tc: '菲律賓',
    sc: '菲律宾',
  },
  {
    countryCode: 'PCN',
    en: 'Pitcairn Island',
    tc: '皮特凱恩島',
    sc: '皮特凯恩岛',
  },
  {
    countryCode: 'POL',
    en: 'Poland',
    tc: '波蘭',
    sc: '波兰',
  },
  {
    countryCode: 'PRT',
    en: 'Portugal',
    tc: '葡萄牙',
    sc: '葡萄牙',
  },
  {
    countryCode: 'PRI',
    en: 'Puerto Rico',
    tc: '波多黎各',
    sc: '波多黎各',
  },
  {
    countryCode: 'QAT',
    en: 'Qatar',
    tc: '卡塔爾',
    sc: '卡塔尔',
  },
  {
    countryCode: 'MDA',
    en: 'Republic of Moldova',
    tc: '摩爾多瓦共和國',
    sc: '摩尔多瓦共和国',
  },
  {
    countryCode: 'REU',
    en: 'Reunion',
    tc: '留尼汪島',
    sc: '留尼汪岛',
  },
  {
    countryCode: 'ROU',
    en: 'Romania',
    tc: '羅馬尼亞',
    sc: '罗马尼亚',
  },
  {
    countryCode: 'RUS',
    en: 'Russia',
    tc: '俄羅斯',
    sc: '俄罗斯',
  },
  {
    countryCode: 'RWA',
    en: 'Rwanda',
    tc: '盧旺達',
    sc: '卢旺达',
  },
  {
    countryCode: 'SHN',
    en: 'Saint Helena',
    tc: '聖赫勒拿島',
    sc: '圣赫勒拿岛',
  },
  {
    countryCode: 'KNA',
    en: 'Saint Kitts and Nevis',
    tc: '聖吉提斯與尼夫斯',
    sc: '圣吉提斯与尼夫斯',
  },
  {
    countryCode: 'LCA',
    en: 'Saint Lucia',
    tc: '聖盧西亞',
    sc: '圣卢西亚',
  },
  {
    countryCode: 'MAF',
    en: 'Saint Martin',
    tc: '聖馬丁島',
    sc: '圣马丁岛',
  },
  {
    countryCode: 'SPM',
    en: 'Saint Pierre & Miquelon',
    tc: '聖皮埃爾赫勒',
    sc: '圣皮埃尔赫勒',
  },
  {
    countryCode: 'VCT',
    en: 'Saint Vincent and the Grenadin',
    tc: '聖文森特',
    sc: '圣文森特',
  },
  {
    countryCode: 'BLM',
    en: 'Saint-Barthelemy',
    tc: '聖巴泰勒米島',
    sc: '圣巴泰勒米岛',
  },
  {
    countryCode: 'WSM',
    en: 'Samoa',
    tc: '西薩摩亞',
    sc: '西萨摩亚',
  },
  {
    countryCode: 'SMR',
    en: 'San Marino',
    tc: '聖馬力諾',
    sc: '圣马力诺',
  },
  {
    countryCode: 'STP',
    en: 'Sao Tome and Principe',
    tc: '聖多美及普林西比',
    sc: '圣多美及普林西比',
  },
  {
    countryCode: 'SAU',
    en: 'Saudi Arabia',
    tc: '沙特阿拉伯',
    sc: '沙特阿拉伯',
  },
  {
    countryCode: 'SEN',
    en: 'Senegal',
    tc: '塞內加爾',
    sc: '塞内加尔',
  },
  {
    countryCode: 'SRB',
    en: 'Serbia',
    tc: '塞爾維亞',
    sc: '塞尔维亚',
  },
  {
    countryCode: 'SYC',
    en: 'Seychelles',
    tc: '塞舌爾',
    sc: '塞舌尔',
  },
  {
    countryCode: 'SLE',
    en: 'Sierra Leone',
    tc: '塞拉利昂',
    sc: '塞拉利昂',
  },
  {
    countryCode: 'SGP',
    en: 'Singapore',
    tc: '新加坡',
    sc: '新加坡',
  },
  {
    countryCode: 'SXM',
    en: 'Sint Maarten',
    tc: '聖馬丁',
    sc: '圣马丁',
  },
  {
    countryCode: 'SVK',
    en: 'Slovakia',
    tc: '斯洛伐克',
    sc: '斯洛伐克',
  },
  {
    countryCode: 'SVN',
    en: 'Slovenia',
    tc: '斯洛文尼亞',
    sc: '斯洛文尼亚',
  },
  {
    countryCode: 'SLB',
    en: 'Solomon Islands',
    tc: '所羅門群島',
    sc: '所罗门群岛',
  },
  {
    countryCode: 'SOM',
    en: 'Somalia',
    tc: '索馬里',
    sc: '索马里',
  },
  {
    countryCode: 'ZAF',
    en: 'South Africa',
    tc: '南非',
    sc: '南非',
  },
  {
    countryCode: 'SSD',
    en: 'South Sudan',
    tc: '南蘇丹',
    sc: '南苏丹',
  },
  {
    countryCode: 'ESP',
    en: 'Spain',
    tc: '西班牙',
    sc: '西班牙',
  },
  {
    countryCode: 'LKA',
    en: 'Sri Lanka',
    tc: '斯里蘭卡',
    sc: '斯里兰卡',
  },
  {
    countryCode: 'SDN',
    en: 'Sudan',
    tc: '蘇丹',
    sc: '苏丹',
  },
  {
    countryCode: 'SUR',
    en: 'Suriname',
    tc: '蘇里南',
    sc: '苏里南',
  },
  {
    countryCode: 'SWZ',
    en: 'Eswatini',
    tc: '斯威士蘭',
    sc: '斯威士兰',
  },
  {
    countryCode: 'SWE',
    en: 'Sweden',
    tc: '瑞典',
    sc: '瑞典',
  },
  {
    countryCode: 'CHE',
    en: 'Switzerland',
    tc: '瑞士',
    sc: '瑞士',
  },
  {
    countryCode: 'SYR',
    en: 'Syria',
    tc: '敘利亞',
    sc: '叙利亚',
  },
  {
    countryCode: 'TWN',
    en: 'Taiwan',
    tc: '台灣',
    sc: '台湾',
  },
  {
    countryCode: 'TJK',
    en: 'Tajikistan',
    tc: '塔吉克',
    sc: '塔吉克',
  },
  {
    countryCode: 'TZA',
    en: 'Tanzania',
    tc: '坦桑尼亞',
    sc: '坦桑尼亚',
  },
  {
    countryCode: 'THA',
    en: 'Thailand',
    tc: '泰國',
    sc: '泰国',
  },
  {
    countryCode: 'TLS',
    en: 'Timor-Leste',
    tc: '東帝汶民主共和國',
    sc: '东帝汶民主共和国',
  },
  {
    countryCode: 'TGO',
    en: 'Togo',
    tc: '多哥',
    sc: '多哥',
  },
  {
    countryCode: 'TON',
    en: 'Tonga',
    tc: '東加',
    sc: '东加',
  },
  {
    countryCode: 'TTO',
    en: 'Trinidad And Tobago',
    tc: '千里達和多巴哥',
    sc: '千里达和多巴哥',
  },
  {
    countryCode: 'TUN',
    en: 'Tunisia',
    tc: '突尼斯',
    sc: '突尼斯',
  },
  {
    countryCode: 'TUR',
    en: 'Turkiye',
    tc: '土耳其',
    sc: '土耳其',
  },
  {
    countryCode: 'TKM',
    en: 'Turkmenistan',
    tc: '土庫曼',
    sc: '土库曼',
  },
  {
    countryCode: 'TCA',
    en: 'Turks & Caicos Island',
    tc: '特克斯和凱科斯群島',
    sc: '特克斯和凯科斯群岛',
  },
  {
    countryCode: 'TUV',
    en: 'Tuvalu',
    tc: '吐瓦魯',
    sc: '吐瓦鲁',
  },
  {
    countryCode: 'UGA',
    en: 'Uganda',
    tc: '烏干達',
    sc: '乌干达',
  },
  {
    countryCode: 'UKR',
    en: 'Ukraine',
    tc: '烏克蘭',
    sc: '乌克兰',
  },
  {
    countryCode: 'ARE',
    en: 'United Arab Emirates',
    tc: '阿拉伯聯合酋長國',
    sc: '阿拉伯联合酋长国',
  },
  {
    countryCode: 'GBR',
    en: 'United Kingdom',
    tc: '英國',
    sc: '英国',
  },
  {
    countryCode: 'VIR',
    en: 'United States Virgin Islands',
    tc: '美屬維京群島',
    sc: '美属维京群岛',
  },
  {
    countryCode: 'URY',
    en: 'Uruguay',
    tc: '烏拉圭',
    sc: '乌拉圭',
  },
  {
    countryCode: 'USA',
    en: 'USA',
    tc: '美國',
    sc: '美国',
  },
  {
    countryCode: 'UZB',
    en: 'Uzbekistan',
    tc: '烏茲別克',
    sc: '乌兹别克',
  },
  {
    countryCode: 'VUT',
    en: 'Vanuatu',
    tc: '瓦努阿圖',
    sc: '瓦努阿图',
  },
  {
    countryCode: 'VEN',
    en: 'Venezuela',
    tc: '委內瑞拉',
    sc: '委内瑞拉',
  },
  {
    countryCode: 'VNM',
    en: 'Vietnam',
    tc: '越南',
    sc: '越南',
  },
  {
    countryCode: 'WLF',
    en: 'Wallis & Futuna Islands',
    tc: '瓦利斯群島和富圖納群島',
    sc: '瓦利斯群岛和富图纳群岛',
  },
  {
    countryCode: 'ESH',
    en: 'Western Sahara',
    tc: '撒哈拉沙漠西部',
    sc: '撒哈拉沙漠西部',
  },
  {
    countryCode: 'YEM',
    en: 'Yemen',
    tc: '也門',
    sc: '也门',
  },
  {
    countryCode: 'ZMB',
    en: 'Zambia',
    tc: '贊比亞',
    sc: '赞比亚',
  },
  {
    countryCode: 'ZWE',
    en: 'Zimbabwe',
    tc: '津巴布韋',
    sc: '津巴布韦',
  },
];
